module.exports = __webpack_public_path__ + "static/media/nosotros02M.eb3e0c5f.jpg";